import { useContext, useCallback } from "react";
import { AnalyticsContext } from "@swiggy-private/checkout-core";
import { ReviewedCart } from "@cart-client/interfaces/Cart";
import { CLICK_ACTIONS, IMPRESSION_ACTIONS, SCREEN_NAME } from "@cart-client/analytics/constants";

export function useDeliveryRenderedAnalytics(cartResponse: ReviewedCart | null) {
    const { clickEvent, impressionEvent } = useContext(AnalyticsContext);
    const cartId = cartResponse?.data?.cartId;
    const originalCartId = cartResponse?.data?.originalCartId;

    const onTabToggleClick = useCallback(
        (option: string) => {
            clickEvent({
                category: SCREEN_NAME.CHECKOUT,
                action: CLICK_ACTIONS.CLICK_DELIVERY_TAB,
                context: JSON.stringify({
                    "toggle-option": option,
                    cartId,
                    originalCartId,
                }),
            });
        },
        [cartId, clickEvent, originalCartId],
    );

    const onTabToggleImpression = useCallback(
        (option: string) => {
            impressionEvent({
                category: SCREEN_NAME.CHECKOUT,
                action: IMPRESSION_ACTIONS.IMPRESSION_DELIVERY_TAB,
                context: JSON.stringify({
                    "toggle-option": option,
                    cartId,
                    originalCartId,
                }),
            });
        },
        [cartId, impressionEvent, originalCartId],
    );

    return {
        onTabToggleClick,
        onTabToggleImpression,
    };
}
